import React, { useState, useEffect } from "react";
import { TabPane, Tab } from "semantic-ui-react";

import Tables from "./tables";
import Tournaments from "./tournaments";
import Table from "./table";
import DataAcor from './DataAcc';
import newUtils from "../newUtils.js";
import decideClass from "../decide.js";

const WEB_URL = "wss://ui.usdtpoker.club";
var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
//var days = ['Sunday'];
const socket = new WebSocket(WEB_URL);
const TabExampleBasic = (prop) => {
  const [gamesData, setGamesData] = useState([]);
  const [jsonData, setJsonData] = useState([]);
  const [gameData, setGameData] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [tableid, setTableid] = useState();
  const getTalbes = () => {
    if (gamesData.length == 0 && activeIndex == 0) {
      var xhr = new XMLHttpRequest();

      xhr.open("GET", "https://ui.usdtpoker.club/loadTables", true);
      xhr.onload = function (e) {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            const _data2 = JSON.parse(xhr.responseText).sort((a, b) => { return a.n < b.n ? 1 : -1 });
            if (_data2 != gamesData) { setGamesData(_data2); }

          } else {
            console.error(xhr.statusText);
          }
        }
      };
      xhr.onerror = function (e) {
        console.error(e);
      };
      xhr.send(null);
    }

  };
  const getJson = () => {
    if (jsonData.length == 0 && activeIndex == 2) {
      var xhr = new XMLHttpRequest();

      xhr.open("GET", "https://ui.usdtpoker.club/loadJson", true);
      xhr.onload = function (e) {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            const _data2 = JSON.parse(xhr.responseText);
            if (_data2 != jsonData) { setJsonData(_data2); }
            localStorage.setItem('jsonData', xhr.responseText)

          } else {
            console.error(xhr.statusText);
          }
        }
      };
      xhr.onerror = function (e) {
        console.error(e);
      };
      xhr.send(null);

    }
  };

  useEffect(() => {
    // Event onopen baraye vaghti ke websocket baz shode

    socket.onopen = () => {
      console.log("WebSocket connected");
    };

    // Event onmessage baraye daryaft data az server
    socket.onmessage = (event) => {
      const data = JSON.parse(event.data); // Parse kardan JSON daryafti
      //console.log("Game data received: ", data);
      if (data.method === "tables" && data.table != []) {

        var _data = data.table;

        if (_data != gameData) {
          var tID = 0
          if (localStorage.getItem('tID')) {
            // tID = parseInt(localStorage.getItem('tID')) + 1;

          }
          //localStorage.setItem('tID', tID)
          // localStorage.setItem(tID + 'table', JSON.stringify(_data))
          // _data.allCards = comine(_data.allCards,_data.flopCards)
          setGameData(_data);
        }
      }
      if (data.method === "connect" && tableid) {
        socket.send(JSON.stringify({ method: "gettable", tableName: tableid }));
      }
      if (data.method === "connect" && !tableid) {
        const _data2 = data.tables.sort((a, b) => { return a.n < b.n ? 1 : -1 });
        if (_data2 != gamesData) { setGamesData(_data2); }
      }

    };

    // Event onclose baraye vaghti ke websocket baste mishe
    socket.onclose = () => {
      console.log("WebSocket closed");
      // setConn(false);
      // _auth = null;
    };

    // Cleanup websocket dar zamane unmount kardan component
    return () => {
      // socket.close();
    };
  }, []);
  useEffect(() => {
    // Event onopen baraye vaghti ke websocket baz shode
    if (tableid) {
      try {
        socket.send(JSON.stringify({ method: "gettable", tableName: tableid }));
        setActiveIndex(1)
      } catch (error) {
        setActiveIndex(1)
      }
      // localStorage.setItem("tableid", tableid)
     
    }
  }, [tableid]);


  const sendData = (method, data) => {
    socket.send(JSON.stringify({ method: method, data: data }));
  };
  const GetTables = (prop) => {
    useEffect(() => {
      prop.getTalbes();
    }, []);

    return <Tables tables={prop.gamesData} setTableid={setTableid} />;
  };
  const GetJsonData = (prop) => {
    useEffect(() => {
      prop.getJson();
    }, []);
    console.log(jsonData);

    if (jsonData["Bots"]) {

      return (
        <>
          {days.map(function (day) {


            return (
              <>
                <DataAcor jsonData={jsonData} day={day} key={day} />


              </>
            )
          })}
        </>
      )
    }

  };


  const GetTable = (prop) => {



    const sendDeside = (data) => {
      prop.socket.send(JSON.stringify({ method: "decide", data: data }));
    };

    useEffect(() => {
      // prop.socket.send(JSON.stringify({ method: "gettable", tableName: localStorage.getItem("tableid") }));
    }, []);
    return <Table table={prop.gameData} sendDeside={sendDeside} />;
  };
  const handleTabChange = (e, { activeIndex }) => setActiveIndex(activeIndex)
  const panes = [
    {
      menuItem: "Tables",
      render: () => (
        <TabPane>
          <GetTables getTalbes={getTalbes} gamesData={gamesData} />
        </TabPane>
      ),
    },

    {
      menuItem: "Table",
      render: () => (
        <TabPane>
          <GetTable gameData={gameData} socket={socket} />
        </TabPane>
      ),
    },
    { menuItem: "Data", render: () => <TabPane><GetJsonData getJson={getJson} jsonData={jsonData} /></TabPane> },
  ];
  return <Tab panes={panes} activeIndex={activeIndex} onTabChange={handleTabChange} {...prop} />;
};

export default TabExampleBasic;
